/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

module.exports.Dispatcher = require('./lib/Dispatcher');



/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/flux/index.js
 ** module id = 615
 ** module chunks = 0 10 12 17 23
 **/